module.exports = "\n  .loading-overlay {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n  }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modulos/encuesta/encuesta.component.css
// module id = ./src/app/modulos/encuesta/encuesta.component.css
// module chunks = main